export const urlcdn = () => {
    let url = '';
    switch (document.location.hostname) {
        case 'www.kommunal-rapport.no':
        // Fallthru - we're on prod now
        case 'www-stage.kommunal-rapport.no':
        // Fallthru - we're on prod now
        case 'https://www-kr-labcluster-espena.labdevs.com':
        // Fallthru - we're on prod now
        default:
            url = "https://cdn.kommunal-rapport.dev";
    }
    return url;
};
